<template>
    <div class="p-5">
        <div>
            <FormInput
                :value="user.lista.id + ' - ' + user.lista.nombre"
                id="lista-activa"
                :disabled="true"
                :label="'Lista de abonados activa'"
                :name="'Lista de abonados activa'"
                class="w-25"
            />
            <Dropzone
                v-if="url"
                :url="url"
                @success="vdropzone_handler"
                @error="vdropzone_handler"
            />
        </div>
        <b-card v-if="mensaje" bg-variant="info" :title="mensaje" style="margin: 20px">
            <b-card-text/>
        </b-card>
        <div style="margin: 20px">
            <h3>Instrucciones para subir una lista de abonados en excel o csv</h3>
            <p>Los abonados se importarán a la lista activa en este momento, la cual aparecerá en el campo de texto superior.</p>
            <p>Si la lista de abonados no está vacía, no se realizará la importación.</p>
            <p>Las comprobaciones sobre la validez de los datos son mínimas. No hay que asumir nada en este sentido.</p>
            <p>De momento no aparecerá ninguna confirmación de éxito o fallo en esta página. Por favor, revisa en otro lugar que esto es correcto.</p>
            <p>El fichero deberá tener NECESARIAMENTE y ÚNICAMENTE las siguientes columnas, aunque estén vacías (con excepciones):</p>
            <div>
                <li><b>n_socio</b></li>
                <li><b>n_socio_nuevo</b></li>
                <li><b>nombre</b>: No puede ser vacío</li>
                <li><b>apellidos</b></li>
                <li><b>nif</b></li>
                <li><b>email</b></li>
                <li><b>provincia</b></li>
                <li><b>localidad</b></li>
                <li><b>domicilio</b></li>
                <li><b>nacimiento</b>: El formato de la fecha ha de ser <i>dd/mm/yyyy</i></li>
                <li><b>telefono</b></li>
                <li><b>movil</b></li>
                <li><b>zona_abono</b></li>
                <li><b>fila</b></li>
                <li><b>asiento</b></li>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue';
    import store from '@/store';
    import Dropzone from '@/components/common/Dropzone';
    import { config } from '@/config.js';

    const mensaje = ref('');
    const url = ref(null);

    const user = computed(() => store.getters.getUser);

    const listaActiva = computed(() => {
        if (!user.value?.lista) return '';
        return `${user.value.lista.id} - ${user.value.lista.nombre}`;
    });

    const vdropzone_handler = (file, response) => {
        if (response?.message) {
            mensaje.value = response.message;
        }
    };

    onMounted(() => {
        if (user.value?.lista?.id) {
            const token = localStorage.getItem('token');
            url.value = `${config.API_BASE}/listas-abonados/${user.value.lista.id}/import/excel?api_key=${token}`;
        }
    });
</script>

